var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main",
    { staticClass: "account-profile container-fluid mt-3 bg-white" },
    [
      _c("div", { staticClass: "row h-100 no-gutters pt-5" }, [
        _c("div", { staticClass: "col-12 mx-lg-auto" }, [
          _c(
            "div",
            {
              staticClass:
                "row no-gutters justify-content-center align-content-start align-content-lg-stretch h-100"
            },
            [
              _c(
                "div",
                {
                  staticClass: "col-12 col-xl-2 col-md-3 pt-lg-6 border-right"
                },
                [_c("pc-side-nav")],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 col-lg mb-3 mb-lg-5 pt-6" }, [
                _c(
                  "section",
                  {
                    staticClass: "mb-5 container-fluid",
                    attrs: { id: "salesrep-section" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "d-flex mb-4 pb-1 border-bottom",
                        attrs: { id: "salesrep-heading" }
                      },
                      [
                        _c(
                          "p",
                          { staticClass: "font-weight-normal text-uppercase" },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "account.AccountSupport.Rep.Label"
                                  ]
                                ) +
                                "\n              "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col" }, [
                        _c("p", [
                          _c("b", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "account.AccountSupport.SalesRep.Label"
                                  ]
                                ) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "\n                  " +
                              _vm._s(
                                _vm.salesrep ? _vm.salesrep.firstName : ""
                              ) +
                              " " +
                              _vm._s(
                                _vm.salesrep ? _vm.salesrep.lastName : ""
                              ) +
                              "\n                "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col" }, [
                        _c("p", [
                          _c("b", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "account.AccountSupport.Contact.Label"
                                  ]
                                ) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              attrs: {
                                href:
                                  "tel:+1" +
                                  (_vm.salesrep
                                    ? _vm.salesrep.phone == null
                                      ? _vm.salesrep.mobilePhone
                                      : _vm.salesrep.phone
                                    : "")
                              }
                            },
                            [
                              _vm._v(
                                "\n                    +1\n                    " +
                                  _vm._s(
                                    _vm.salesrep
                                      ? _vm.salesrep.phone == null
                                        ? _vm.salesrep.mobilePhone
                                        : _vm.salesrep.phone
                                      : ""
                                  ) +
                                  "\n                  "
                              )
                            ]
                          )
                        ])
                      ])
                    ])
                  ]
                )
              ])
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }